import { defineMessages } from 'react-intl';

import * as D from './deps';

export const DOMAIN_NAME = 'playlistT3' as const;

export const messages = defineMessages({
  addSimilarSongs: {
    id: 't.addSimilarSongs',
    defaultMessage: 'Add similar songs',
  },
  addToPlaylist: {
    id: 't.addToPlaylist',
    defaultMessage: 'Add to Playlist',
  },
  cancel: {
    id: 't.cancel',
    defaultMessage: 'Cancel',
  },
  deletePlaylistBody: {
    id: 't.deletePlaylistBody',
    defaultMessage: 'Are you sure you want to remove "{playlistName}" from your collection?',
  },
  deletePlaylistTitle: {
    id: 't.deletePlaylistTitle',
    defaultMessage: 'Delete Playlist',
  },
  delete: {
    id: 't.delete',
    defaultMessage: 'Delete',
  },
  playlistHeaderTitle: {
    id: 't.playlistHeaderTitle',
    defaultMessage: 'Playlist',
  },
  recommendedSongs: {
    id: 't.recommendedSongs',
    defaultMessage: 'RECOMMENDED SONGS',
  },
  recommendedSongsHelperText: {
    id: 't.recommendedSongsHelperText',
    defaultMessage:
      'Recommended songs available.  Keyboard users: use up and down arrow or tab keys to navigate recommended songs and enter to select. Press escape to clear and return to the search input field.',
  },
  searchSongsHelperText: {
    id: 't.searchSongsHelperText',
    defaultMessage:
      'Search results available.  Keyboard users: use up and down arrow or tab keys to navigate search results and enter to select. Press escape to clear and return to the search input field.',
  },
  onInsertTrackSuccessMessage: {
    id: 't.onInsertTrackSuccessMessage',
    defaultMessage: 'Track added to playlist.',
  },
  privatePlaylistShare: {
    id: 't.privatePlaylistShare',
    defaultMessage: 'Private playlists cannot be shared.',
  },
  privatePlaylistCollect: {
    id: 't.privatePlaylistCollect',
    defaultMessage: 'Private playlists cannot be collected.',
  },
});

// used to hook up drag-and-drop sources with targets
export const PLAYLIST_TRACK = 'playlistTrack' as const;

export const ReducerKeys = Object.freeze({
  PLAYLISTS: 'playlists',
  GET_TRACKS_OFFSETS_FETCHED: 'GET_TRACKS_OFFSETS_FETCHED',
  GET_TRACKS_OFFSETS_FETCHING: 'GET_TRACKS_OFFSETS_FETCHING',
  TRACKS_BEING_DELETED: 'TRACKS_BEING_DELETED',
} as const);

export const LinkedStationPlaylist = Object.freeze({
  PLAYLIST_LINKED_TYPE: 'stationthumbs',
  PLAYLIST_CREATE_SOURCE_ID: 'stationthumbs',
} as const);

export const DirectionKeys = Object.freeze({
  FIRST: 'first',
  NEXT: 'next',
  PREVIOUS: 'previous',
} as const);

// page size for fetching new load of tracks from server
export const PLAYLIST_PAGE_SIZE = 20 as const;

export const DRAG_IMAGE_SIZE = 5.6 * D.Constants.Styling.remToPixelRatio;

// drag zone set to 3/4 of a list item height
export const DRAG_SCROLL_ZONE_SIZE = 7.5 * D.Constants.Styling.remToPixelRatio;
export const DRAG_FOOTER_SIZE = 66 as const;
export const DRAG_HEADER_SIZE = 64 as const;
